import api from "../services/api";

// Push nativo (Web Push / VAPID). Notifica com o app fechado, inclusive no
// iPhone (iOS 16.4+, PWA instalado na tela de inicio). Usa o NOSSO sw.js, sem
// depender de terceiro.

// A chave VAPID vem do servidor em base64url; o navegador quer um Uint8Array.
const base64ParaUint8 = (base64) => {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const cru = atob(b64);
  const arr = new Uint8Array(cru.length);
  for (let i = 0; i < cru.length; i += 1) arr[i] = cru.charCodeAt(i);
  return arr;
};

export const pushSuportado = () =>
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

// "sem-suporte" | "bloqueado" | "ativo" | "inativo"
export const statusPush = async () => {
  if (!pushSuportado()) return "sem-suporte";
  if (Notification.permission === "denied") return "bloqueado";
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return sub ? "ativo" : "inativo";
};

export const ativarPush = async () => {
  if (!pushSuportado()) {
    throw new Error("Este navegador nao suporta notificacoes push.");
  }

  // iOS EXIGE que o pedido de permissao venha de um toque do usuario — por
  // isso esta funcao so e chamada a partir do clique no botao.
  const permissao = await Notification.requestPermission();
  if (permissao !== "granted") {
    throw new Error(
      "Permissao negada. Libere as notificacoes deste site e tente de novo.",
    );
  }

  const reg = await navigator.serviceWorker.ready;

  const { data } = await api.get("/push/vapid-public-key");
  const chave = data && data.publicKey;
  if (!chave) {
    throw new Error("O servidor esta sem chave de push configurada.");
  }

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64ParaUint8(chave),
    });
  }

  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: sub.endpoint,
    p256dh: json.keys.p256dh,
    auth: json.keys.auth,
  });

  return true;
};

export const desativarPush = async () => {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (sub) {
    try {
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    } catch (e) {
      /* segue e cancela localmente mesmo se o servidor falhar */
    }
    await sub.unsubscribe();
  }
  return true;
};

export const testarPush = async () => {
  await api.post("/push/test");
};
